import React, { useState, useRef } from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { Col, FormGroup, Label, Input } from 'reactstrap';
import { useHistory } from 'react-router';
import SimpleReactValidator from 'simple-react-validator';
import classNames from 'classnames';
import styles from '../Sales/CustomerInfo.module.css';
import ModalHeader from 'react-bootstrap/ModalHeader';
import SpinnerButton from '../shared/SpinnerButton/SpinnerButton';
import CheckboxInput from '../shared/CheckboxInput/CheckboxInput';
import { useCookies } from 'react-cookie';
const SaveModal = ({
    isOpen,
    toggle,
    centered,
    customerData,
    checked,
    planData,
    isSavedForLater,
    clientId,
    comingFrom,
    promoCodeData,
    isAgent
}) => {
    console.log(customerData, planData);

    const history = useHistory();
    const [, forceUpdate] = useState();
    const [termsAndCondition, setTermsAndCondition] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [cookies] = useCookies();
    const simpleValidator = useRef(
        new SimpleReactValidator({
            messages: {
                email: 'Please enter a valid email.',
                required: ':attribute is required.'
            },
            element: (message) => (
                <div
                    className='errorMsg'
                    aria-live='polite'
                >
                    {message.charAt(0).toUpperCase() + message.slice(1)}
                </div>
            )
        })
    );

    const [formData, setFormData] = useState({
        invitationNumber: customerData.invitationNumber ? customerData.invitationNumber : '0',
        firstName: customerData.firstName ? customerData.firstName : '',
        lastName: customerData.lastName ? customerData.lastName : '',
        phone: customerData.phone ? customerData.phone : '',
        email: customerData.email ? customerData.email : '',
        serviceAddress: customerData.serviceAddress,
        mailingAddress: customerData.mailingAddress,
        billingAddress: customerData.billingAddress,
        doNotSolicit: customerData.doNotSolicit ? customerData.doNotSolicit : new Date('01/01/01'),
        termsAndCondition: customerData.termsAndCondition,
        riskProfileModel: planData.selectedPlan.riskProfile,
        activeAddPlans: planData.selectedAddPlans.map((i) => i.riskProfile),
        isMailingAddress: customerData.isMailingAddress,
        plan: customerData.plan,
        isPayment: false,
        savedPage: comingFrom,
        planDocuments: customerData.planDocuments
    });

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleDoNotSolicit = () => {
        let solicitDate;
        setTermsAndCondition(!termsAndCondition);
        solicitDate = !termsAndCondition ? new Date() : null;
        setFormData({
            ...formData,
            doNotSolicit: solicitDate,
            termsAndCondition: termsAndCondition
        });
    };
    const handleSave = (e) => {
        e.preventDefault();
        if (simpleValidator.current.allValid()) {
            /* todo service call*/
            setIsSpinning(true); //  FOR SPINNER  BUTTON FUNCTIONALITY
            let riskProfile = planData.selectedPlan.riskProfile;
            let addOns = planData.selectedAddPlans.map((i) => i.riskProfile);
            let statusCode = 0;
            let planDocuments = customerData.planDocuments;
            let formDataModel = {
                invitationNumber: formData.invitationNumber ? formData.invitationNumber : '0',
                firstName: formData.firstName ? formData.firstName : '',
                lastName: formData.lastName ? formData.lastName : '',
                phone: formData.phone ? formData.phone : '',
                email: formData.email ? formData.email : '',
                serviceAddress: formData.serviceAddress,
                mailingAddress: formData.mailingAddress,
                billingAddress: formData.billingAddress,
                doNotSolicit: formData.doNotSolicit ? formData.doNotSolicit : new Date('01/01/2001 5:00:00 AM'),
                termsAndCondition: false,
                riskProfileModel: riskProfile,
                activeAddPlans: addOns,
                isPayment: false,
                savedStep: comingFrom,
                autoRenewal: true,
                promoCode: promoCodeData?.name,
                planDocumentsType: formData.planDocuments,
                tsfAmount: parseFloat(planData?.tsf?.term)?.toFixed(2)
            };

            fetch(`api/Contract/CreatePlanContract/${clientId}/${isAgent}`, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    XSRFTOKEN: cookies.XSRFTOKEN
                },
                body: JSON.stringify(formDataModel)
            })
                .then(function (res) {
                    statusCode = res.status;
                    return res.json();
                })
                .then((contractData) => {
                    if (statusCode === 204) {
                    }
                    if (statusCode === 200) {
                        // let contractNumber = contractData.contractNumber;

                        history.push({
                            pathname: '/confirmation/2',
                            state: {
                                invitationNumber: contractData.clientContractNumber,
                                isYearly: formData?.riskProfileModel?.name?.toLowerCase()?.includes('annual'),
                                amount: 0,
                                riskProfileName: formDataModel?.riskProfileModel?.name,
                                isPayment: false,
                                isSaved: false
                            }
                        });
                    }
                });
        } else {
            simpleValidator.current.showMessages();
            forceUpdate(1);
            //toggle(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered={centered}
            className='modal-md'
            aria-labelledBy='save'
        >
            <ModalHeader
                id='save'
                className={classNames('modal-header', styles.saveCardHeader)}
            >
                <h3 className='h4'>Save My Quote</h3>
            </ModalHeader>

            <ModalBody>
                <div style={{ textAlign: 'left' }}>
                    <Col
                        md='12'
                        className='p-0 mb-3'
                    >
                        <p>
                            Enter your email address to save this quote for later. You can resume your quote from the
                            confirmation email you receive.
                        </p>
                    </Col>
                    <Col
                        md='6'
                        id='serviceAddressFieldsSaveModal'
                        className='p-0 mb-3'
                    >
                        <FormGroup>
                            <Label
                                for='saveModalEmail'
                                className='form-label'
                            >
                                Email
                            </Label>
                            <span
                                aria-hidden='true'
                                className='required-indicator'
                            >
                                *
                            </span>
                            <Input
                                type='text'
                                className='form-control'
                                id='saveModalEmail'
                                type='email'
                                name='email'
                                value={formData.email}
                                onChange={handleInputChange}
                                aria-required='true'
                            />
                            {simpleValidator.current.message('email', formData.email, 'required|email')}
                        </FormGroup>
                    </Col>
                    <Col
                        md='12'
                        className='p-0'
                    >
                        <CheckboxInput
                            clientId={clientId}
                            id='termsAndConditions'
                            checked={formData.termsAndCondition}
                            handleCheck={handleDoNotSolicit}
                        >
                            I do not wish to receive special offers, promotions or other email marketing communications
                            from NJR Retail. All information we gather is governed by our{' '}
                            <a
                                href='https://www.njrhomeservices.com/privacy-disclosures'
                                target='_blank'
                                className={styles.privacyLink}
                            >
                                privacy statement
                            </a>
                            .
                        </CheckboxInput>
                    </Col>
                </div>
            </ModalBody>

            <ModalFooter>
                <div className={styles.customerInfoBtnWrapper}>
                    <button
                        className={classNames('btnLink')}
                        onClick={toggle}
                    >
                        Cancel
                    </button>
                    <SpinnerButton
                        type='primary'
                        text='Continue'
                        spinning={isSpinning}
                        onClick={handleSave}
                        disabled={isSpinning}
                        ariaLabel='Click to save your data'
                    />
                </div>
            </ModalFooter>
        </Modal>
    );
};

export default SaveModal;
